import { Check, Monitor, Moon, Sun } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useTheme } from "./theme-provider"

const themes = [
	{
		value: "light" as const,
		label: "Light",
		icon: Sun,
	},
	{
		value: "dark" as const,
		label: "Dark",
		icon: Moon,
	},
	{
		value: "system" as const,
		label: "System",
		icon: Monitor,
	},
] as const

export function ThemeToggle() {
	const { theme, setTheme, systemTheme, resolvedTheme } = useTheme()

	// Get the current theme icon for the trigger button
	const CurrentThemeIcon =
		themes.find((t) => t.value === theme)?.icon ?? Monitor

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="ghost"
					size="icon"
					aria-label={`Current theme: ${theme}${
						theme === "system" ? ` (${systemTheme})` : ""
					}. Resolved theme: ${resolvedTheme}. Click to change theme`}
				>
					<CurrentThemeIcon className="h-[1.2rem] w-[1.2rem] transition-all" />
					<span className="sr-only">Toggle theme</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="min-w-[8rem]">
				{themes.map((themeOption) => {
					const Icon = themeOption.icon
					const isSelected = theme === themeOption.value
					const label =
						themeOption.value === "system"
							? `${themeOption.label} (${systemTheme})`
							: themeOption.label

					return (
						<DropdownMenuItem
							key={themeOption.value}
							onClick={() => setTheme(themeOption.value)}
							className="flex items-center gap-2"
						>
							<Icon className="h-4 w-4" />
							<span className="flex-1">{label}</span>
							{isSelected && <Check className="h-4 w-4 text-primary" />}
						</DropdownMenuItem>
					)
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
